import api from "./axios";
import type { Subcategory } from "@/types";

export const getSubcategories = (categoryId?: string) => {
  const params = categoryId ? { categoryId } : {};
  return api
    .get<Subcategory[]>("/subcategories", { params })
    .then((r) => r.data);
};

export const createSubcategory = (data: {
  name: string;
  description?: string;
  categoryId: string;
}) => api.post<Subcategory>("/subcategories", data).then((r) => r.data);

export const updateSubcategory = (
  id: string,
  data: { name?: string; description?: string; categoryId?: string },
) => api.patch<Subcategory>(`/subcategories/${id}`, data).then((r) => r.data);

export const deleteSubcategory = (id: string) =>
  api.delete(`/subcategories/${id}`).then((r) => r.data);
